document.addEventListener('DOMContentLoaded',function(){
  let MidSliderMN = new Swiper('.LayoutMarqueeExposedWp.swiper',{
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    },
    slidesPerView: 'auto',
    speed: 5000,
    grabCursor: true,
    mousewheelControl: true,
    keyboardControl: true,
  })
  let ProductGridSlider = document.querySelectorAll('.sliderwpProductGrid > .LayoutProductGrid__Innovation > .Loop_productsGridBoost');
  ProductGridSlider.forEach( (evt)=>{
    var swiper = new Swiper(evt, {
      slidesPerView: 1.3,
      spaceBetween: 20,
      centeredSlides: true,
      breakpoints: {
        768: { 
          slidesPerView: 1.7,
          spaceBetween: 40,
          centeredSlides: false
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 40,
          centeredSlides: false
        }
      }
    })
  });
  
  let ContentSlider = new Swiper('.EB_InnovCntSldrMNSider.swiper, .CustomerSaysinv.swiper',{
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  })

  var scrollerLink = document.querySelectorAll('.EB_InnovDifrItemBtn');
  if(scrollerLink)
  scrollerLink.forEach(function(evt){
    evt.addEventListener('click',function(e){
      e.preventDefault();
      var linkerInit = this.querySelector('a').getAttribute('href');
      document.querySelector(linkerInit).scrollIntoView({top : 100, behavior: 'smooth'});
    })
  })
})

class productGrid extends HTMLElement{
  constructor(){
    super();
    this.minimizeSwatches();
    if (this.querySelectorAll('.ElmNextRow').length > 0){ this.querySelector('.ElmNextRow').addEventListener('click', this.expandview.bind(this)); }
    this.querySelectorAll('input').forEach( (evt)=>{ evt.addEventListener('change', this.variantimageChange.bind(this)); })
  }
  variantimageChange(target){
    let vmain_image = target.target.getAttribute('variant_main_image');
    let vhover_image = target.target.getAttribute('variant_hover_image');
    let vid = target.target.getAttribute('variant_id');
    let updatevid = this.querySelector('.ProductViewButton__Grid > a').getAttribute('href');
    updatevid = updatevid.split('?variant=')[0];
    this.querySelector('.mnImage__Wp__main > div').innerHTML = `<img src="${vmain_image}&width=400" loading="eager">`;
    this.querySelector('.mnImage__Wp__hover > div').innerHTML = `<img src="${vhover_image}&width=400" loading="eager">`;
    this.querySelector('.ProductViewButton__Grid > a').setAttribute('href',`${updatevid}?variant=${vid}`);
  }
  expandview(){
    this.querySelectorAll('.InputRadioProductGrid').forEach((evt,index)=>{ evt.classList.remove('hide') });
  }
  minimizeSwatches(){
    let counter = 0;
    if ( window.screen.width >= 1280 ) {
        let GetColor = this.querySelectorAll('.InputRadioProductGrid').length;if ( GetColor > 9 ){    this.querySelectorAll('.InputRadioProductGrid').forEach((evt,index)=>{let final = parseInt(GetColor - 9);if ( index == 0 ) {counter = 0;} else {counter++;}if ( index == 8 ){ if( this.querySelectorAll('.ElmNextRow').length == 0 ){let Countelm = document.createElement("DIV"); Countelm.textContent = '+'+final;Countelm.classList.add('ElmNextRow'); evt.after(Countelm)}}if( counter > 8 ){evt.classList.add('hide');}}) }          
    }else if ( window.screen.width >= 749 && window.screen.width < 1280) {
        let GetColor = this.querySelectorAll('.InputRadioProductGrid').length;if ( GetColor > 6 ){    this.querySelectorAll('.InputRadioProductGrid').forEach((evt,index)=>{let final = parseInt(GetColor - 6);if ( index == 0 ) {counter = 0;} else {counter++;}if ( index == 5 ){ if( this.querySelectorAll('.ElmNextRow').length == 0 ){let Countelm = document.createElement("DIV"); Countelm.textContent = '+'+final;Countelm.classList.add('ElmNextRow'); evt.after(Countelm)}}if( counter > 5 ){evt.classList.add('hide');}}) }          
    }else if ( window.screen.width >= 320 && window.screen.width < 749) {
        let GetColor = this.querySelectorAll('.InputRadioProductGrid').length;if ( GetColor > 5 ){    this.querySelectorAll('.InputRadioProductGrid').forEach((evt,index)=>{let final = parseInt(GetColor - 5);if ( index == 0 ) {counter = 0;} else {counter++;}if ( index == 4 ){ if( this.querySelectorAll('.ElmNextRow').length == 0 ){let Countelm = document.createElement("DIV"); Countelm.textContent = '+'+final;Countelm.classList.add('ElmNextRow'); evt.after(Countelm)}}if( counter > 4 ){evt.classList.add('hide');}}) }          
    }        
  }
}
customElements.define('cus-productgrid-layout',productGrid);